export const COUNTRIES_DATA = [
  {
    value: 'AU',
    label: 'Australia',
    name: 'Australia',
    isoCode: 'AU',
    flag: '🇦🇺',
    phonecode: '61',
    currency: 'AUD',
    latitude: '-27.00000000',
    longitude: '133.00000000',
    timezones: [
      {
        zoneName: 'Antarctica/Macquarie',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'MIST',
        tzName: 'Macquarie Island Station Time',
      },
      {
        zoneName: 'Australia/Adelaide',
        gmtOffset: 37800,
        gmtOffsetName: 'UTC+10:30',
        abbreviation: 'ACDT',
        tzName: 'Australian Central Daylight Saving Time',
      },
      {
        zoneName: 'Australia/Brisbane',
        gmtOffset: 36000,
        gmtOffsetName: 'UTC+10:00',
        abbreviation: 'AEST',
        tzName: 'Australian Eastern Standard Time',
      },
      {
        zoneName: 'Australia/Broken_Hill',
        gmtOffset: 37800,
        gmtOffsetName: 'UTC+10:30',
        abbreviation: 'ACDT',
        tzName: 'Australian Central Daylight Saving Time',
      },
      {
        zoneName: 'Australia/Currie',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'AEDT',
        tzName: 'Australian Eastern Daylight Saving Time',
      },
      {
        zoneName: 'Australia/Darwin',
        gmtOffset: 34200,
        gmtOffsetName: 'UTC+09:30',
        abbreviation: 'ACST',
        tzName: 'Australian Central Standard Time',
      },
      {
        zoneName: 'Australia/Eucla',
        gmtOffset: 31500,
        gmtOffsetName: 'UTC+08:45',
        abbreviation: 'ACWST',
        tzName: 'Australian Central Western Standard Time (Unofficial)',
      },
      {
        zoneName: 'Australia/Hobart',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'AEDT',
        tzName: 'Australian Eastern Daylight Saving Time',
      },
      {
        zoneName: 'Australia/Lindeman',
        gmtOffset: 36000,
        gmtOffsetName: 'UTC+10:00',
        abbreviation: 'AEST',
        tzName: 'Australian Eastern Standard Time',
      },
      {
        zoneName: 'Australia/Lord_Howe',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'LHST',
        tzName: 'Lord Howe Summer Time',
      },
      {
        zoneName: 'Australia/Melbourne',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'AEDT',
        tzName: 'Australian Eastern Daylight Saving Time',
      },
      {
        zoneName: 'Australia/Perth',
        gmtOffset: 28800,
        gmtOffsetName: 'UTC+08:00',
        abbreviation: 'AWST',
        tzName: 'Australian Western Standard Time',
      },
      {
        zoneName: 'Australia/Sydney',
        gmtOffset: 39600,
        gmtOffsetName: 'UTC+11:00',
        abbreviation: 'AEDT',
        tzName: 'Australian Eastern Daylight Saving Time',
      },
    ],
  },
  {
    value: 'CA',
    label: 'Canada',
    name: 'Canada',
    isoCode: 'CA',
    flag: '🇨🇦',
    phonecode: '1',
    currency: 'CAD',
    latitude: '60.00000000',
    longitude: '-95.00000000',
    timezones: [
      {
        zoneName: 'America/Atikokan',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America)',
      },
      {
        zoneName: 'America/Blanc-Sablon',
        gmtOffset: -14400,
        gmtOffsetName: 'UTC-04:00',
        abbreviation: 'AST',
        tzName: 'Atlantic Standard Time',
      },
      {
        zoneName: 'America/Cambridge_Bay',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Creston',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Dawson',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Dawson_Creek',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Edmonton',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Fort_Nelson',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America)',
      },
      {
        zoneName: 'America/Glace_Bay',
        gmtOffset: -14400,
        gmtOffsetName: 'UTC-04:00',
        abbreviation: 'AST',
        tzName: 'Atlantic Standard Time',
      },
      {
        zoneName: 'America/Goose_Bay',
        gmtOffset: -14400,
        gmtOffsetName: 'UTC-04:00',
        abbreviation: 'AST',
        tzName: 'Atlantic Standard Time',
      },
      {
        zoneName: 'America/Halifax',
        gmtOffset: -14400,
        gmtOffsetName: 'UTC-04:00',
        abbreviation: 'AST',
        tzName: 'Atlantic Standard Time',
      },
      {
        zoneName: 'America/Inuvik',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
      {
        zoneName: 'America/Iqaluit',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Moncton',
        gmtOffset: -14400,
        gmtOffsetName: 'UTC-04:00',
        abbreviation: 'AST',
        tzName: 'Atlantic Standard Time',
      },
      {
        zoneName: 'America/Nipigon',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Pangnirtung',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Rainy_River',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Rankin_Inlet',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Regina',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Resolute',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/St_Johns',
        gmtOffset: -12600,
        gmtOffsetName: 'UTC-03:30',
        abbreviation: 'NST',
        tzName: 'Newfoundland Standard Time',
      },
      {
        zoneName: 'America/Swift_Current',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Thunder_Bay',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Toronto',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Vancouver',
        gmtOffset: -28800,
        gmtOffsetName: 'UTC-08:00',
        abbreviation: 'PST',
        tzName: 'Pacific Standard Time (North America',
      },
      {
        zoneName: 'America/Whitehorse',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
      {
        zoneName: 'America/Winnipeg',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Yellowknife',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
    ],
  },
  {
    value: 'IE',
    label: 'Ireland',
    name: 'Ireland',
    isoCode: 'IE',
    flag: '🇮🇪',
    phonecode: '353',
    currency: 'EUR',
    latitude: '53.00000000',
    longitude: '-8.00000000',
    timezones: [
      {
        zoneName: 'Europe/Dublin',
        gmtOffset: 0,
        gmtOffsetName: 'UTC±00',
        abbreviation: 'GMT',
        tzName: 'Greenwich Mean Time',
      },
    ],
  },
  {
    value: 'ZA',
    label: 'South Africa',
    name: 'South Africa',
    isoCode: 'ZA',
    flag: '🇿🇦',
    phonecode: '27',
    currency: 'ZAR',
    latitude: '-29.00000000',
    longitude: '24.00000000',
    timezones: [
      {
        zoneName: 'Africa/Johannesburg',
        gmtOffset: 7200,
        gmtOffsetName: 'UTC+02:00',
        abbreviation: 'SAST',
        tzName: 'South African Standard Time',
      },
    ],
  },
  {
    value: 'GB',
    label: 'United Kingdom',
    name: 'United Kingdom',
    isoCode: 'GB',
    flag: '🇬🇧',
    phonecode: '44',
    currency: 'GBP',
    latitude: '54.00000000',
    longitude: '-2.00000000',
    timezones: [
      {
        zoneName: 'Europe/London',
        gmtOffset: 0,
        gmtOffsetName: 'UTC±00',
        abbreviation: 'GMT',
        tzName: 'Greenwich Mean Time',
      },
    ],
  },
  {
    value: 'US',
    label: 'United States',
    name: 'United States',
    isoCode: 'US',
    flag: '🇺🇸',
    phonecode: '1',
    currency: 'USD',
    latitude: '38.00000000',
    longitude: '-97.00000000',
    timezones: [
      {
        zoneName: 'America/Adak',
        gmtOffset: -36000,
        gmtOffsetName: 'UTC-10:00',
        abbreviation: 'HST',
        tzName: 'Hawaii–Aleutian Standard Time',
      },
      {
        zoneName: 'America/Anchorage',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'America/Boise',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
      {
        zoneName: 'America/Chicago',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Denver',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
      {
        zoneName: 'America/Detroit',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Indianapolis',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Knox',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Marengo',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Petersburg',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Tell_City',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Vevay',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Vincennes',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Indiana/Winamac',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Juneau',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'America/Kentucky/Louisville',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Kentucky/Monticello',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Los_Angeles',
        gmtOffset: -28800,
        gmtOffsetName: 'UTC-08:00',
        abbreviation: 'PST',
        tzName: 'Pacific Standard Time (North America',
      },
      {
        zoneName: 'America/Menominee',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Metlakatla',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'America/New_York',
        gmtOffset: -18000,
        gmtOffsetName: 'UTC-05:00',
        abbreviation: 'EST',
        tzName: 'Eastern Standard Time (North America',
      },
      {
        zoneName: 'America/Nome',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'America/North_Dakota/Beulah',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/North_Dakota/Center',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/North_Dakota/New_Salem',
        gmtOffset: -21600,
        gmtOffsetName: 'UTC-06:00',
        abbreviation: 'CST',
        tzName: 'Central Standard Time (North America',
      },
      {
        zoneName: 'America/Phoenix',
        gmtOffset: -25200,
        gmtOffsetName: 'UTC-07:00',
        abbreviation: 'MST',
        tzName: 'Mountain Standard Time (North America',
      },
      {
        zoneName: 'America/Sitka',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'America/Yakutat',
        gmtOffset: -32400,
        gmtOffsetName: 'UTC-09:00',
        abbreviation: 'AKST',
        tzName: 'Alaska Standard Time',
      },
      {
        zoneName: 'Pacific/Honolulu',
        gmtOffset: -36000,
        gmtOffsetName: 'UTC-10:00',
        abbreviation: 'HST',
        tzName: 'Hawaii–Aleutian Standard Time',
      },
    ],
  },
];

export const STATES_DATA = {
  US: [
    {
      value: 'AL',
      label: 'Alabama',
    },
    {
      value: 'AK',
      label: 'Alaska',
    },
    {
      value: 'AS',
      label: 'American Samoa',
    },
    {
      value: 'AZ',
      label: 'Arizona',
    },
    {
      value: 'AR',
      label: 'Arkansas',
    },
    {
      value: 'UM-81',
      label: 'Baker Island',
    },
    {
      value: 'CA',
      label: 'California',
    },
    {
      value: 'CO',
      label: 'Colorado',
    },
    {
      value: 'CT',
      label: 'Connecticut',
    },
    {
      value: 'DE',
      label: 'Delaware',
    },
    {
      value: 'DC',
      label: 'District of Columbia',
    },
    {
      value: 'FL',
      label: 'Florida',
    },
    {
      value: 'GA',
      label: 'Georgia',
    },
    {
      value: 'GU',
      label: 'Guam',
    },
    {
      value: 'HI',
      label: 'Hawaii',
    },
    {
      value: 'UM-84',
      label: 'Howland Island',
    },
    {
      value: 'ID',
      label: 'Idaho',
    },
    {
      value: 'IL',
      label: 'Illinois',
    },
    {
      value: 'IN',
      label: 'Indiana',
    },
    {
      value: 'IA',
      label: 'Iowa',
    },
    {
      value: 'UM-86',
      label: 'Jarvis Island',
    },
    {
      value: 'UM-67',
      label: 'Johnston Atoll',
    },
    {
      value: 'KS',
      label: 'Kansas',
    },
    {
      value: 'KY',
      label: 'Kentucky',
    },
    {
      value: 'UM-89',
      label: 'Kingman Reef',
    },
    {
      value: 'LA',
      label: 'Louisiana',
    },
    {
      value: 'ME',
      label: 'Maine',
    },
    {
      value: 'MD',
      label: 'Maryland',
    },
    {
      value: 'MA',
      label: 'Massachusetts',
    },
    {
      value: 'MI',
      label: 'Michigan',
    },
    {
      value: 'UM-71',
      label: 'Midway Atoll',
    },
    {
      value: 'MN',
      label: 'Minnesota',
    },
    {
      value: 'MS',
      label: 'Mississippi',
    },
    {
      value: 'MO',
      label: 'Missouri',
    },
    {
      value: 'MT',
      label: 'Montana',
    },
    {
      value: 'UM-76',
      label: 'Navassa Island',
    },
    {
      value: 'NE',
      label: 'Nebraska',
    },
    {
      value: 'NV',
      label: 'Nevada',
    },
    {
      value: 'NH',
      label: 'New Hampshire',
    },
    {
      value: 'NJ',
      label: 'New Jersey',
    },
    {
      value: 'NM',
      label: 'New Mexico',
    },
    {
      value: 'NY',
      label: 'New York',
    },
    {
      value: 'NC',
      label: 'North Carolina',
    },
    {
      value: 'ND',
      label: 'North Dakota',
    },
    {
      value: 'MP',
      label: 'Northern Mariana Islands',
    },
    {
      value: 'OH',
      label: 'Ohio',
    },
    {
      value: 'OK',
      label: 'Oklahoma',
    },
    {
      value: 'OR',
      label: 'Oregon',
    },
    {
      value: 'UM-95',
      label: 'Palmyra Atoll',
    },
    {
      value: 'PA',
      label: 'Pennsylvania',
    },
    {
      value: 'PR',
      label: 'Puerto Rico',
    },
    {
      value: 'RI',
      label: 'Rhode Island',
    },
    {
      value: 'SC',
      label: 'South Carolina',
    },
    {
      value: 'SD',
      label: 'South Dakota',
    },
    {
      value: 'TN',
      label: 'Tennessee',
    },
    {
      value: 'TX',
      label: 'Texas',
    },
    {
      value: 'UM',
      label: 'United States Minor Outlying Islands',
    },
    {
      value: 'VI',
      label: 'United States Virgin Islands',
    },
    {
      value: 'UT',
      label: 'Utah',
    },
    {
      value: 'VT',
      label: 'Vermont',
    },
    {
      value: 'VA',
      label: 'Virginia',
    },
    {
      value: 'UM-79',
      label: 'Wake Island',
    },
    {
      value: 'WA',
      label: 'Washington',
    },
    {
      value: 'WV',
      label: 'West Virginia',
    },
    {
      value: 'WI',
      label: 'Wisconsin',
    },
    {
      value: 'WY',
      label: 'Wyoming',
    },
  ],
  GB: [
    {
      value: 'ABE',
      label: 'Aberdeen',
    },
    {
      value: 'ABD',
      label: 'Aberdeenshire',
    },
    {
      value: 'ANS',
      label: 'Angus',
    },
    {
      value: 'ANT',
      label: 'Antrim',
    },
    {
      value: 'ANN',
      label: 'Antrim and Newtownabbey',
    },
    {
      value: 'ARD',
      label: 'Ards',
    },
    {
      value: 'AND',
      label: 'Ards and North Down',
    },
    {
      value: 'AGB',
      label: 'Argyll and Bute',
    },
    {
      value: 'ARM',
      label: 'Armagh City and District Council',
    },
    {
      value: 'ABC',
      label: 'Armagh, Banbridge and Craigavon',
    },
    {
      value: 'SH-AC',
      label: 'Ascension Island',
    },
    {
      value: 'BLA',
      label: 'Ballymena Borough',
    },
    {
      value: 'BLY',
      label: 'Ballymoney',
    },
    {
      value: 'BNB',
      label: 'Banbridge',
    },
    {
      value: 'BNS',
      label: 'Barnsley',
    },
    {
      value: 'BAS',
      label: 'Bath and North East Somerset',
    },
    {
      value: 'BDF',
      label: 'Bedford',
    },
    {
      value: 'BFS',
      label: 'Belfast district',
    },
    {
      value: 'BIR',
      label: 'Birmingham',
    },
    {
      value: 'BBD',
      label: 'Blackburn with Darwen',
    },
    {
      value: 'BPL',
      label: 'Blackpool',
    },
    {
      value: 'BGW',
      label: 'Blaenau Gwent County Borough',
    },
    {
      value: 'BOL',
      label: 'Bolton',
    },
    {
      value: 'BMH',
      label: 'Bournemouth',
    },
    {
      value: 'BRC',
      label: 'Bracknell Forest',
    },
    {
      value: 'BRD',
      label: 'Bradford',
    },
    {
      value: 'BGE',
      label: 'Bridgend County Borough',
    },
    {
      value: 'BNH',
      label: 'Brighton and Hove',
    },
    {
      value: 'BKM',
      label: 'Buckinghamshire',
    },
    {
      value: 'BUR',
      label: 'Bury',
    },
    {
      value: 'CAY',
      label: 'Caerphilly County Borough',
    },
    {
      value: 'CLD',
      label: 'Calderdale',
    },
    {
      value: 'CAM',
      label: 'Cambridgeshire',
    },
    {
      value: 'CMN',
      label: 'Carmarthenshire',
    },
    {
      value: 'CKF',
      label: 'Carrickfergus Borough Council',
    },
    {
      value: 'CSR',
      label: 'Castlereagh',
    },
    {
      value: 'CCG',
      label: 'Causeway Coast and Glens',
    },
    {
      value: 'CBF',
      label: 'Central Bedfordshire',
    },
    {
      value: 'CGN',
      label: 'Ceredigion',
    },
    {
      value: 'CHE',
      label: 'Cheshire East',
    },
    {
      value: 'CHW',
      label: 'Cheshire West and Chester',
    },
    {
      value: 'CRF',
      label: 'City and County of Cardiff',
    },
    {
      value: 'SWA',
      label: 'City and County of Swansea',
    },
    {
      value: 'BST',
      label: 'City of Bristol',
    },
    {
      value: 'DER',
      label: 'City of Derby',
    },
    {
      value: 'KHL',
      label: 'City of Kingston upon Hull',
    },
    {
      value: 'LCE',
      label: 'City of Leicester',
    },
    {
      value: 'LND',
      label: 'City of London',
    },
    {
      value: 'NGM',
      label: 'City of Nottingham',
    },
    {
      value: 'PTE',
      label: 'City of Peterborough',
    },
    {
      value: 'PLY',
      label: 'City of Plymouth',
    },
    {
      value: 'POR',
      label: 'City of Portsmouth',
    },
    {
      value: 'STH',
      label: 'City of Southampton',
    },
    {
      value: 'STE',
      label: 'City of Stoke-on-Trent',
    },
    {
      value: 'SND',
      label: 'City of Sunderland',
    },
    {
      value: 'WSM',
      label: 'City of Westminster',
    },
    {
      value: 'WLV',
      label: 'City of Wolverhampton',
    },
    {
      value: 'YOR',
      label: 'City of York',
    },
    {
      value: 'CLK',
      label: 'Clackmannanshire',
    },
    {
      value: 'CLR',
      label: 'Coleraine Borough Council',
    },
    {
      value: 'CWY',
      label: 'Conwy County Borough',
    },
    {
      value: 'CKT',
      label: 'Cookstown District Council',
    },
    {
      value: 'CON',
      label: 'Cornwall',
    },
    {
      value: 'DUR',
      label: 'County Durham',
    },
    {
      value: 'COV',
      label: 'Coventry',
    },
    {
      value: 'CGV',
      label: 'Craigavon Borough Council',
    },
    {
      value: 'CMA',
      label: 'Cumbria',
    },
    {
      value: 'DAL',
      label: 'Darlington',
    },
    {
      value: 'DEN',
      label: 'Denbighshire',
    },
    {
      value: 'DBY',
      label: 'Derbyshire',
    },
    {
      value: 'DRY',
      label: 'Derry City Council',
    },
    {
      value: 'DRS',
      label: 'Derry City and Strabane',
    },
    {
      value: 'DEV',
      label: 'Devon',
    },
    {
      value: 'DNC',
      label: 'Doncaster',
    },
    {
      value: 'DOR',
      label: 'Dorset',
    },
    {
      value: 'DOW',
      label: 'Down District Council',
    },
    {
      value: 'DUD',
      label: 'Dudley',
    },
    {
      value: 'DGY',
      label: 'Dumfries and Galloway',
    },
    {
      value: 'DND',
      label: 'Dundee',
    },
    {
      value: 'DGN',
      label: 'Dungannon and South Tyrone Borough Council',
    },
    {
      value: 'EAY',
      label: 'East Ayrshire',
    },
    {
      value: 'EDU',
      label: 'East Dunbartonshire',
    },
    {
      value: 'ELN',
      label: 'East Lothian',
    },
    {
      value: 'ERW',
      label: 'East Renfrewshire',
    },
    {
      value: 'ERY',
      label: 'East Riding of Yorkshire',
    },
    {
      value: 'ESX',
      label: 'East Sussex',
    },
    {
      value: 'EDH',
      label: 'Edinburgh',
    },
    {
      value: 'ENG',
      label: 'England',
    },
    {
      value: 'ESS',
      label: 'Essex',
    },
    {
      value: 'FAL',
      label: 'Falkirk',
    },
    {
      value: 'FER',
      label: 'Fermanagh District Council',
    },
    {
      value: 'FMO',
      label: 'Fermanagh and Omagh',
    },
    {
      value: 'FIF',
      label: 'Fife',
    },
    {
      value: 'FLN',
      label: 'Flintshire',
    },
    {
      value: 'GAT',
      label: 'Gateshead',
    },
    {
      value: 'GLG',
      label: 'Glasgow',
    },
    {
      value: 'GLS',
      label: 'Gloucestershire',
    },
    {
      value: 'GWN',
      label: 'Gwynedd',
    },
    {
      value: 'HAL',
      label: 'Halton',
    },
    {
      value: 'HAM',
      label: 'Hampshire',
    },
    {
      value: 'HPL',
      label: 'Hartlepool',
    },
    {
      value: 'HEF',
      label: 'Herefordshire',
    },
    {
      value: 'HRT',
      label: 'Hertfordshire',
    },
    {
      value: 'HLD',
      label: 'Highland',
    },
    {
      value: 'IVC',
      label: 'Inverclyde',
    },
    {
      value: 'IOW',
      label: 'Isle of Wight',
    },
    {
      value: 'IOS',
      label: 'Isles of Scilly',
    },
    {
      value: 'KEN',
      label: 'Kent',
    },
    {
      value: 'KIR',
      label: 'Kirklees',
    },
    {
      value: 'KWL',
      label: 'Knowsley',
    },
    {
      value: 'LAN',
      label: 'Lancashire',
    },
    {
      value: 'LRN',
      label: 'Larne Borough Council',
    },
    {
      value: 'LDS',
      label: 'Leeds',
    },
    {
      value: 'LEC',
      label: 'Leicestershire',
    },
    {
      value: 'LMV',
      label: 'Limavady Borough Council',
    },
    {
      value: 'LIN',
      label: 'Lincolnshire',
    },
    {
      value: 'LSB',
      label: 'Lisburn City Council',
    },
    {
      value: 'LBC',
      label: 'Lisburn and Castlereagh',
    },
    {
      value: 'LIV',
      label: 'Liverpool',
    },
    {
      value: 'BDG',
      label: 'London Borough of Barking and Dagenham',
    },
    {
      value: 'BNE',
      label: 'London Borough of Barnet',
    },
    {
      value: 'BEX',
      label: 'London Borough of Bexley',
    },
    {
      value: 'BEN',
      label: 'London Borough of Brent',
    },
    {
      value: 'BRY',
      label: 'London Borough of Bromley',
    },
    {
      value: 'CMD',
      label: 'London Borough of Camden',
    },
    {
      value: 'CRY',
      label: 'London Borough of Croydon',
    },
    {
      value: 'EAL',
      label: 'London Borough of Ealing',
    },
    {
      value: 'ENF',
      label: 'London Borough of Enfield',
    },
    {
      value: 'HCK',
      label: 'London Borough of Hackney',
    },
    {
      value: 'HMF',
      label: 'London Borough of Hammersmith and Fulham',
    },
    {
      value: 'HRY',
      label: 'London Borough of Haringey',
    },
    {
      value: 'HRW',
      label: 'London Borough of Harrow',
    },
    {
      value: 'HAV',
      label: 'London Borough of Havering',
    },
    {
      value: 'HIL',
      label: 'London Borough of Hillingdon',
    },
    {
      value: 'HNS',
      label: 'London Borough of Hounslow',
    },
    {
      value: 'ISL',
      label: 'London Borough of Islington',
    },
    {
      value: 'LBH',
      label: 'London Borough of Lambeth',
    },
    {
      value: 'LEW',
      label: 'London Borough of Lewisham',
    },
    {
      value: 'MRT',
      label: 'London Borough of Merton',
    },
    {
      value: 'NWM',
      label: 'London Borough of Newham',
    },
    {
      value: 'RDB',
      label: 'London Borough of Redbridge',
    },
    {
      value: 'RIC',
      label: 'London Borough of Richmond upon Thames',
    },
    {
      value: 'SWK',
      label: 'London Borough of Southwark',
    },
    {
      value: 'STN',
      label: 'London Borough of Sutton',
    },
    {
      value: 'TWH',
      label: 'London Borough of Tower Hamlets',
    },
    {
      value: 'WFT',
      label: 'London Borough of Waltham Forest',
    },
    {
      value: 'WND',
      label: 'London Borough of Wandsworth',
    },
    {
      value: 'MFT',
      label: 'Magherafelt District Council',
    },
    {
      value: 'MAN',
      label: 'Manchester',
    },
    {
      value: 'MDW',
      label: 'Medway',
    },
    {
      value: 'MTY',
      label: 'Merthyr Tydfil County Borough',
    },
    {
      value: 'WGN',
      label: 'Metropolitan Borough of Wigan',
    },
    {
      value: 'MUL',
      label: 'Mid Ulster',
    },
    {
      value: 'MEA',
      label: 'Mid and East Antrim',
    },
    {
      value: 'MDB',
      label: 'Middlesbrough',
    },
    {
      value: 'MLN',
      label: 'Midlothian',
    },
    {
      value: 'MIK',
      label: 'Milton Keynes',
    },
    {
      value: 'MON',
      label: 'Monmouthshire',
    },
    {
      value: 'MRY',
      label: 'Moray',
    },
    {
      value: 'MYL',
      label: 'Moyle District Council',
    },
    {
      value: 'NTL',
      label: 'Neath Port Talbot County Borough',
    },
    {
      value: 'NET',
      label: 'Newcastle upon Tyne',
    },
    {
      value: 'NWP',
      label: 'Newport',
    },
    {
      value: 'NYM',
      label: 'Newry and Mourne District Council',
    },
    {
      value: 'NMD',
      label: 'Newry, Mourne and Down',
    },
    {
      value: 'NTA',
      label: 'Newtownabbey Borough Council',
    },
    {
      value: 'NFK',
      label: 'Norfolk',
    },
    {
      value: 'NAY',
      label: 'North Ayrshire',
    },
    {
      value: 'NDN',
      label: 'North Down Borough Council',
    },
    {
      value: 'NEL',
      label: 'North East Lincolnshire',
    },
    {
      value: 'NLK',
      label: 'North Lanarkshire',
    },
    {
      value: 'NLN',
      label: 'North Lincolnshire',
    },
    {
      value: 'NSM',
      label: 'North Somerset',
    },
    {
      value: 'NTY',
      label: 'North Tyneside',
    },
    {
      value: 'NYK',
      label: 'North Yorkshire',
    },
    {
      value: 'NTH',
      label: 'Northamptonshire',
    },
    {
      value: 'NIR',
      label: 'Northern Ireland',
    },
    {
      value: 'NBL',
      label: 'Northumberland',
    },
    {
      value: 'NTT',
      label: 'Nottinghamshire',
    },
    {
      value: 'OLD',
      label: 'Oldham',
    },
    {
      value: 'OMH',
      label: 'Omagh District Council',
    },
    {
      value: 'ORK',
      label: 'Orkney Islands',
    },
    {
      value: 'ELS',
      label: 'Outer Hebrides',
    },
    {
      value: 'OXF',
      label: 'Oxfordshire',
    },
    {
      value: 'PEM',
      label: 'Pembrokeshire',
    },
    {
      value: 'PKN',
      label: 'Perth and Kinross',
    },
    {
      value: 'POL',
      label: 'Poole',
    },
    {
      value: 'POW',
      label: 'Powys',
    },
    {
      value: 'RDG',
      label: 'Reading',
    },
    {
      value: 'RCC',
      label: 'Redcar and Cleveland',
    },
    {
      value: 'RFW',
      label: 'Renfrewshire',
    },
    {
      value: 'RCT',
      label: 'Rhondda Cynon Taf',
    },
    {
      value: 'RCH',
      label: 'Rochdale',
    },
    {
      value: 'ROT',
      label: 'Rotherham',
    },
    {
      value: 'GRE',
      label: 'Royal Borough of Greenwich',
    },
    {
      value: 'KEC',
      label: 'Royal Borough of Kensington and Chelsea',
    },
    {
      value: 'KTT',
      label: 'Royal Borough of Kingston upon Thames',
    },
    {
      value: 'RUT',
      label: 'Rutland',
    },
    {
      value: 'SH-HL',
      label: 'Saint Helena',
    },
    {
      value: 'SLF',
      label: 'Salford',
    },
    {
      value: 'SAW',
      label: 'Sandwell',
    },
    {
      value: 'SCT',
      label: 'Scotland',
    },
    {
      value: 'SCB',
      label: 'Scottish Borders',
    },
    {
      value: 'SFT',
      label: 'Sefton',
    },
    {
      value: 'SHF',
      label: 'Sheffield',
    },
    {
      value: 'ZET',
      label: 'Shetland Islands',
    },
    {
      value: 'SHR',
      label: 'Shropshire',
    },
    {
      value: 'SLG',
      label: 'Slough',
    },
    {
      value: 'SOL',
      label: 'Solihull',
    },
    {
      value: 'SOM',
      label: 'Somerset',
    },
    {
      value: 'SAY',
      label: 'South Ayrshire',
    },
    {
      value: 'SGC',
      label: 'South Gloucestershire',
    },
    {
      value: 'SLK',
      label: 'South Lanarkshire',
    },
    {
      value: 'STY',
      label: 'South Tyneside',
    },
    {
      value: 'SOS',
      label: 'Southend-on-Sea',
    },
    {
      value: 'SHN',
      label: 'St Helens',
    },
    {
      value: 'STS',
      label: 'Staffordshire',
    },
    {
      value: 'STG',
      label: 'Stirling',
    },
    {
      value: 'SKP',
      label: 'Stockport',
    },
    {
      value: 'STT',
      label: 'Stockton-on-Tees',
    },
    {
      value: 'STB',
      label: 'Strabane District Council',
    },
    {
      value: 'SFK',
      label: 'Suffolk',
    },
    {
      value: 'SRY',
      label: 'Surrey',
    },
    {
      value: 'SWD',
      label: 'Swindon',
    },
    {
      value: 'TAM',
      label: 'Tameside',
    },
    {
      value: 'TFW',
      label: 'Telford and Wrekin',
    },
    {
      value: 'THR',
      label: 'Thurrock',
    },
    {
      value: 'TOB',
      label: 'Torbay',
    },
    {
      value: 'TOF',
      label: 'Torfaen',
    },
    {
      value: 'TRF',
      label: 'Trafford',
    },
    {
      value: 'UKM',
      label: 'United Kingdom',
    },
    {
      value: 'VGL',
      label: 'Vale of Glamorgan',
    },
    {
      value: 'WKF',
      label: 'Wakefield',
    },
    {
      value: 'WLS',
      label: 'Wales',
    },
    {
      value: 'WLL',
      label: 'Walsall',
    },
    {
      value: 'WRT',
      label: 'Warrington',
    },
    {
      value: 'WAR',
      label: 'Warwickshire',
    },
    {
      value: 'WBK',
      label: 'West Berkshire',
    },
    {
      value: 'WDU',
      label: 'West Dunbartonshire',
    },
    {
      value: 'WLN',
      label: 'West Lothian',
    },
    {
      value: 'WSX',
      label: 'West Sussex',
    },
    {
      value: 'WIL',
      label: 'Wiltshire',
    },
    {
      value: 'WNM',
      label: 'Windsor and Maidenhead',
    },
    {
      value: 'WRL',
      label: 'Wirral',
    },
    {
      value: 'WOK',
      label: 'Wokingham',
    },
    {
      value: 'WOR',
      label: 'Worcestershire',
    },
    {
      value: 'WRX',
      label: 'Wrexham County Borough',
    },
  ],
  AU: [
    {
      value: 'ACT',
      label: 'Australian Capital Territory',
    },
    {
      value: 'NSW',
      label: 'New South Wales',
    },
    {
      value: 'NT',
      label: 'Northern Territory',
    },
    {
      value: 'QLD',
      label: 'Queensland',
    },
    {
      value: 'SA',
      label: 'South Australia',
    },
    {
      value: 'TAS',
      label: 'Tasmania',
    },
    {
      value: 'VIC',
      label: 'Victoria',
    },
    {
      value: 'WA',
      label: 'Western Australia',
    },
  ],
  CA: [
    {
      value: 'AB',
      label: 'Alberta',
    },
    {
      value: 'BC',
      label: 'British Columbia',
    },
    {
      value: 'MB',
      label: 'Manitoba',
    },
    {
      value: 'NB',
      label: 'New Brunswick',
    },
    {
      value: 'NL',
      label: 'Newfoundland and Labrador',
    },
    {
      value: 'NT',
      label: 'Northwest Territories',
    },
    {
      value: 'NS',
      label: 'Nova Scotia',
    },
    {
      value: 'NU',
      label: 'Nunavut',
    },
    {
      value: 'ON',
      label: 'Ontario',
    },
    {
      value: 'PE',
      label: 'Prince Edward Island',
    },
    {
      value: 'QC',
      label: 'Quebec',
    },
    {
      value: 'SK',
      label: 'Saskatchewan',
    },
    {
      value: 'YT',
      label: 'Yukon',
    },
  ],
  IE: [
    {
      value: 'CW',
      label: 'Carlow',
    },
    {
      value: 'CN',
      label: 'Cavan',
    },
    {
      value: 'CE',
      label: 'Clare',
    },
    {
      value: 'C',
      label: 'Connacht',
    },
    {
      value: 'CO',
      label: 'Cork',
    },
    {
      value: 'DL',
      label: 'Donegal',
    },
    {
      value: 'D',
      label: 'Dublin',
    },
    {
      value: 'G',
      label: 'Galway',
    },
    {
      value: 'KY',
      label: 'Kerry',
    },
    {
      value: 'KE',
      label: 'Kildare',
    },
    {
      value: 'KK',
      label: 'Kilkenny',
    },
    {
      value: 'LS',
      label: 'Laois',
    },
    {
      value: 'L',
      label: 'Leinster',
    },
    {
      value: 'LK',
      label: 'Limerick',
    },
    {
      value: 'LD',
      label: 'Longford',
    },
    {
      value: 'LH',
      label: 'Louth',
    },
    {
      value: 'MO',
      label: 'Mayo',
    },
    {
      value: 'MH',
      label: 'Meath',
    },
    {
      value: 'MN',
      label: 'Monaghan',
    },
    {
      value: 'M',
      label: 'Munster',
    },
    {
      value: 'OY',
      label: 'Offaly',
    },
    {
      value: 'RN',
      label: 'Roscommon',
    },
    {
      value: 'SO',
      label: 'Sligo',
    },
    {
      value: 'TA',
      label: 'Tipperary',
    },
    {
      value: 'U',
      label: 'Ulster',
    },
    {
      value: 'WD',
      label: 'Waterford',
    },
    {
      value: 'WH',
      label: 'Westmeath',
    },
    {
      value: 'WX',
      label: 'Wexford',
    },
    {
      value: 'WW',
      label: 'Wicklow',
    },
  ],
  ZA: [
    {
      value: 'EC',
      label: 'Eastern Cape',
    },
    {
      value: 'FS',
      label: 'Free State',
    },
    {
      value: 'GP',
      label: 'Gauteng',
    },
    {
      value: 'KZN',
      label: 'KwaZulu-Natal',
    },
    {
      value: 'LP',
      label: 'Limpopo',
    },
    {
      value: 'MP',
      label: 'Mpumalanga',
    },
    {
      value: 'NW',
      label: 'North West',
    },
    {
      value: 'NC',
      label: 'Northern Cape',
    },
    {
      value: 'WC',
      label: 'Western Cape',
    },
  ],
};

export const SUPPORTED_COUNTRIES = [
  'US', // United States
  'GB', // United Kingdom
  'AU', // Australia
  'CA', // Canada
  'IE', // Ireland
  'ZA', // South Africa
];

// Phone prefixes for supported countries
export const PHONE_PREFIXES = [
  {
    value: '+61',
    label: '+61 Australia',
  },
  {
    value: '+1',
    label: '+1 US/Canada',
  },
  {
    value: '+353',
    label: '+353 Ireland',
  },
  {
    value: '+27',
    label: '+27 South Africa',
  },
  {
    value: '+44',
    label: '+44 UK',
  },
];

export const TIMEZONES_INTL = [
  {
    name: 'Africa/Addis_Ababa',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Algiers',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Asmera',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Bangui',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Blantyre',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Brazzaville',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Bujumbura',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Cairo',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Casablanca',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Ceuta',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Dar_es_Salaam',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Djibouti',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Douala',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/El_Aaiun',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Gaborone',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Harare',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Johannesburg',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Juba',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Kampala',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Khartoum',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Kigali',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Kinshasa',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Lagos',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Libreville',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Luanda',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Lubumbashi',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Lusaka',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Malabo',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Maputo',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Maseru',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Mbabane',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Mogadishu',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Nairobi',
    offset: 'GMT+03:00',
  },
  {
    name: 'Africa/Ndjamena',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Niamey',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Porto-Novo',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Tripoli',
    offset: 'GMT+02:00',
  },
  {
    name: 'Africa/Tunis',
    offset: 'GMT+01:00',
  },
  {
    name: 'Africa/Windhoek',
    offset: 'GMT+02:00',
  },
  {
    name: 'America/Adak',
    offset: 'GMT-10:00',
  },
  {
    name: 'America/Anchorage',
    offset: 'GMT-09:00',
  },
  {
    name: 'America/Anguilla',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Antigua',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Araguaina',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/La_Rioja',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/Rio_Gallegos',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/Salta',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/San_Juan',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/San_Luis',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/Tucuman',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Argentina/Ushuaia',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Aruba',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Asuncion',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Bahia',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Bahia_Banderas',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Barbados',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Belem',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Belize',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Blanc-Sablon',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Boa_Vista',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Bogota',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Boise',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Buenos_Aires',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Cambridge_Bay',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Campo_Grande',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Cancun',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Caracas',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Catamarca',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Cayenne',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Cayman',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Chicago',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Chihuahua',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Ciudad_Juarez',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Coral_Harbour',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Cordoba',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Costa_Rica',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Coyhaique',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Creston',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Cuiaba',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Curacao',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Dawson',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Dawson_Creek',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Denver',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Detroit',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Dominica',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Edmonton',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Eirunepe',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/El_Salvador',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Fort_Nelson',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Fortaleza',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Glace_Bay',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Godthab',
    offset: 'GMT-02:00',
  },
  {
    name: 'America/Goose_Bay',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Grand_Turk',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Grenada',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Guadeloupe',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Guatemala',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Guayaquil',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Guyana',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Halifax',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Havana',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Hermosillo',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Indiana/Knox',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Indiana/Marengo',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Indiana/Petersburg',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Indiana/Tell_City',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Indiana/Vevay',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Indiana/Vincennes',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Indiana/Winamac',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Indianapolis',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Inuvik',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Iqaluit',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Jamaica',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Jujuy',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Juneau',
    offset: 'GMT-09:00',
  },
  {
    name: 'America/Kentucky/Monticello',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Kralendijk',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/La_Paz',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Lima',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Los_Angeles',
    offset: 'GMT-08:00',
  },
  {
    name: 'America/Louisville',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Lower_Princes',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Maceio',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Managua',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Manaus',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Marigot',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Martinique',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Matamoros',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Mazatlan',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Mendoza',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Menominee',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Merida',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Metlakatla',
    offset: 'GMT-09:00',
  },
  {
    name: 'America/Mexico_City',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Miquelon',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Moncton',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Monterrey',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Montevideo',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Montserrat',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Nassau',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/New_York',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Nome',
    offset: 'GMT-09:00',
  },
  {
    name: 'America/Noronha',
    offset: 'GMT-02:00',
  },
  {
    name: 'America/North_Dakota/Beulah',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/North_Dakota/Center',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/North_Dakota/New_Salem',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Ojinaga',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Panama',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Paramaribo',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Phoenix',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Port-au-Prince',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Port_of_Spain',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Porto_Velho',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Puerto_Rico',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Punta_Arenas',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Rankin_Inlet',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Recife',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Regina',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Resolute',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Rio_Branco',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Santarem',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Santiago',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Santo_Domingo',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Sao_Paulo',
    offset: 'GMT-03:00',
  },
  {
    name: 'America/Scoresbysund',
    offset: 'GMT-02:00',
  },
  {
    name: 'America/Sitka',
    offset: 'GMT-09:00',
  },
  {
    name: 'America/St_Barthelemy',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/St_Johns',
    offset: 'GMT-03:30',
  },
  {
    name: 'America/St_Kitts',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/St_Lucia',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/St_Thomas',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/St_Vincent',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Swift_Current',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Tegucigalpa',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Thule',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Tijuana',
    offset: 'GMT-08:00',
  },
  {
    name: 'America/Toronto',
    offset: 'GMT-05:00',
  },
  {
    name: 'America/Tortola',
    offset: 'GMT-04:00',
  },
  {
    name: 'America/Vancouver',
    offset: 'GMT-08:00',
  },
  {
    name: 'America/Whitehorse',
    offset: 'GMT-07:00',
  },
  {
    name: 'America/Winnipeg',
    offset: 'GMT-06:00',
  },
  {
    name: 'America/Yakutat',
    offset: 'GMT-09:00',
  },
  {
    name: 'Antarctica/Casey',
    offset: 'GMT+08:00',
  },
  {
    name: 'Antarctica/Davis',
    offset: 'GMT+07:00',
  },
  {
    name: 'Antarctica/DumontDUrville',
    offset: 'GMT+10:00',
  },
  {
    name: 'Antarctica/Macquarie',
    offset: 'GMT+11:00',
  },
  {
    name: 'Antarctica/Mawson',
    offset: 'GMT+05:00',
  },
  {
    name: 'Antarctica/McMurdo',
    offset: 'GMT+13:00',
  },
  {
    name: 'Antarctica/Palmer',
    offset: 'GMT-03:00',
  },
  {
    name: 'Antarctica/Rothera',
    offset: 'GMT-03:00',
  },
  {
    name: 'Antarctica/Syowa',
    offset: 'GMT+03:00',
  },
  {
    name: 'Antarctica/Vostok',
    offset: 'GMT+05:00',
  },
  {
    name: 'Arctic/Longyearbyen',
    offset: 'GMT+01:00',
  },
  {
    name: 'Asia/Aden',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Almaty',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Amman',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Anadyr',
    offset: 'GMT+12:00',
  },
  {
    name: 'Asia/Aqtau',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Aqtobe',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Ashgabat',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Atyrau',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Baghdad',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Bahrain',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Baku',
    offset: 'GMT+04:00',
  },
  {
    name: 'Asia/Bangkok',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Barnaul',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Beirut',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Bishkek',
    offset: 'GMT+06:00',
  },
  {
    name: 'Asia/Brunei',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Calcutta',
    offset: 'GMT+05:30',
  },
  {
    name: 'Asia/Chita',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Colombo',
    offset: 'GMT+05:30',
  },
  {
    name: 'Asia/Damascus',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Dhaka',
    offset: 'GMT+06:00',
  },
  {
    name: 'Asia/Dili',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Dubai',
    offset: 'GMT+04:00',
  },
  {
    name: 'Asia/Dushanbe',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Famagusta',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Gaza',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Hebron',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Hong_Kong',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Hovd',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Irkutsk',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Jakarta',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Jayapura',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Jerusalem',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Kabul',
    offset: 'GMT+04:30',
  },
  {
    name: 'Asia/Kamchatka',
    offset: 'GMT+12:00',
  },
  {
    name: 'Asia/Karachi',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Katmandu',
    offset: 'GMT+05:45',
  },
  {
    name: 'Asia/Khandyga',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Krasnoyarsk',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Kuala_Lumpur',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Kuching',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Kuwait',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Macau',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Magadan',
    offset: 'GMT+11:00',
  },
  {
    name: 'Asia/Makassar',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Manila',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Muscat',
    offset: 'GMT+04:00',
  },
  {
    name: 'Asia/Nicosia',
    offset: 'GMT+02:00',
  },
  {
    name: 'Asia/Novokuznetsk',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Novosibirsk',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Omsk',
    offset: 'GMT+06:00',
  },
  {
    name: 'Asia/Oral',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Phnom_Penh',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Pontianak',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Pyongyang',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Qatar',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Qostanay',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Qyzylorda',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Rangoon',
    offset: 'GMT+06:30',
  },
  {
    name: 'Asia/Riyadh',
    offset: 'GMT+03:00',
  },
  {
    name: 'Asia/Saigon',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Sakhalin',
    offset: 'GMT+11:00',
  },
  {
    name: 'Asia/Samarkand',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Seoul',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Shanghai',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Singapore',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Srednekolymsk',
    offset: 'GMT+11:00',
  },
  {
    name: 'Asia/Taipei',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Tashkent',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Tbilisi',
    offset: 'GMT+04:00',
  },
  {
    name: 'Asia/Tehran',
    offset: 'GMT+03:30',
  },
  {
    name: 'Asia/Thimphu',
    offset: 'GMT+06:00',
  },
  {
    name: 'Asia/Tokyo',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Tomsk',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Ulaanbaatar',
    offset: 'GMT+08:00',
  },
  {
    name: 'Asia/Urumqi',
    offset: 'GMT+06:00',
  },
  {
    name: 'Asia/Ust-Nera',
    offset: 'GMT+10:00',
  },
  {
    name: 'Asia/Vientiane',
    offset: 'GMT+07:00',
  },
  {
    name: 'Asia/Vladivostok',
    offset: 'GMT+10:00',
  },
  {
    name: 'Asia/Yakutsk',
    offset: 'GMT+09:00',
  },
  {
    name: 'Asia/Yekaterinburg',
    offset: 'GMT+05:00',
  },
  {
    name: 'Asia/Yerevan',
    offset: 'GMT+04:00',
  },
  {
    name: 'Atlantic/Azores',
    offset: 'GMT-01:00',
  },
  {
    name: 'Atlantic/Bermuda',
    offset: 'GMT-04:00',
  },
  {
    name: 'Atlantic/Cape_Verde',
    offset: 'GMT-01:00',
  },
  {
    name: 'Atlantic/South_Georgia',
    offset: 'GMT-02:00',
  },
  {
    name: 'Atlantic/Stanley',
    offset: 'GMT-03:00',
  },
  {
    name: 'Australia/Adelaide',
    offset: 'GMT+10:30',
  },
  {
    name: 'Australia/Brisbane',
    offset: 'GMT+10:00',
  },
  {
    name: 'Australia/Broken_Hill',
    offset: 'GMT+10:30',
  },
  {
    name: 'Australia/Darwin',
    offset: 'GMT+09:30',
  },
  {
    name: 'Australia/Eucla',
    offset: 'GMT+08:45',
  },
  {
    name: 'Australia/Hobart',
    offset: 'GMT+11:00',
  },
  {
    name: 'Australia/Lindeman',
    offset: 'GMT+10:00',
  },
  {
    name: 'Australia/Lord_Howe',
    offset: 'GMT+11:00',
  },
  {
    name: 'Australia/Melbourne',
    offset: 'GMT+11:00',
  },
  {
    name: 'Australia/Perth',
    offset: 'GMT+08:00',
  },
  {
    name: 'Australia/Sydney',
    offset: 'GMT+11:00',
  },
  {
    name: 'Europe/Amsterdam',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Andorra',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Astrakhan',
    offset: 'GMT+04:00',
  },
  {
    name: 'Europe/Athens',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Belgrade',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Berlin',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Bratislava',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Brussels',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Bucharest',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Budapest',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Busingen',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Chisinau',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Copenhagen',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Gibraltar',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Helsinki',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Istanbul',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Kaliningrad',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Kiev',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Kirov',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Ljubljana',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Luxembourg',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Madrid',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Malta',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Mariehamn',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Minsk',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Monaco',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Moscow',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Oslo',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Paris',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Podgorica',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Prague',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Riga',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Rome',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Samara',
    offset: 'GMT+04:00',
  },
  {
    name: 'Europe/San_Marino',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Sarajevo',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Saratov',
    offset: 'GMT+04:00',
  },
  {
    name: 'Europe/Simferopol',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Skopje',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Sofia',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Stockholm',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Tallinn',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Tirane',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Ulyanovsk',
    offset: 'GMT+04:00',
  },
  {
    name: 'Europe/Vaduz',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Vatican',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Vienna',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Vilnius',
    offset: 'GMT+02:00',
  },
  {
    name: 'Europe/Volgograd',
    offset: 'GMT+03:00',
  },
  {
    name: 'Europe/Warsaw',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Zagreb',
    offset: 'GMT+01:00',
  },
  {
    name: 'Europe/Zurich',
    offset: 'GMT+01:00',
  },
  {
    name: 'Indian/Antananarivo',
    offset: 'GMT+03:00',
  },
  {
    name: 'Indian/Chagos',
    offset: 'GMT+06:00',
  },
  {
    name: 'Indian/Christmas',
    offset: 'GMT+07:00',
  },
  {
    name: 'Indian/Cocos',
    offset: 'GMT+06:30',
  },
  {
    name: 'Indian/Comoro',
    offset: 'GMT+03:00',
  },
  {
    name: 'Indian/Kerguelen',
    offset: 'GMT+05:00',
  },
  {
    name: 'Indian/Mahe',
    offset: 'GMT+04:00',
  },
  {
    name: 'Indian/Maldives',
    offset: 'GMT+05:00',
  },
  {
    name: 'Indian/Mauritius',
    offset: 'GMT+04:00',
  },
  {
    name: 'Indian/Mayotte',
    offset: 'GMT+03:00',
  },
  {
    name: 'Indian/Reunion',
    offset: 'GMT+04:00',
  },
  {
    name: 'Pacific/Apia',
    offset: 'GMT+13:00',
  },
  {
    name: 'Pacific/Auckland',
    offset: 'GMT+13:00',
  },
  {
    name: 'Pacific/Bougainville',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Chatham',
    offset: 'GMT+13:45',
  },
  {
    name: 'Pacific/Easter',
    offset: 'GMT-05:00',
  },
  {
    name: 'Pacific/Efate',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Enderbury',
    offset: 'GMT+13:00',
  },
  {
    name: 'Pacific/Fakaofo',
    offset: 'GMT+13:00',
  },
  {
    name: 'Pacific/Fiji',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Funafuti',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Galapagos',
    offset: 'GMT-06:00',
  },
  {
    name: 'Pacific/Gambier',
    offset: 'GMT-09:00',
  },
  {
    name: 'Pacific/Guadalcanal',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Guam',
    offset: 'GMT+10:00',
  },
  {
    name: 'Pacific/Honolulu',
    offset: 'GMT-10:00',
  },
  {
    name: 'Pacific/Kiritimati',
    offset: 'GMT+14:00',
  },
  {
    name: 'Pacific/Kosrae',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Kwajalein',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Majuro',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Marquesas',
    offset: 'GMT-09:30',
  },
  {
    name: 'Pacific/Midway',
    offset: 'GMT-11:00',
  },
  {
    name: 'Pacific/Nauru',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Niue',
    offset: 'GMT-11:00',
  },
  {
    name: 'Pacific/Norfolk',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Noumea',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Pago_Pago',
    offset: 'GMT-11:00',
  },
  {
    name: 'Pacific/Palau',
    offset: 'GMT+09:00',
  },
  {
    name: 'Pacific/Pitcairn',
    offset: 'GMT-08:00',
  },
  {
    name: 'Pacific/Ponape',
    offset: 'GMT+11:00',
  },
  {
    name: 'Pacific/Port_Moresby',
    offset: 'GMT+10:00',
  },
  {
    name: 'Pacific/Rarotonga',
    offset: 'GMT-10:00',
  },
  {
    name: 'Pacific/Saipan',
    offset: 'GMT+10:00',
  },
  {
    name: 'Pacific/Tahiti',
    offset: 'GMT-10:00',
  },
  {
    name: 'Pacific/Tarawa',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Tongatapu',
    offset: 'GMT+13:00',
  },
  {
    name: 'Pacific/Truk',
    offset: 'GMT+10:00',
  },
  {
    name: 'Pacific/Wake',
    offset: 'GMT+12:00',
  },
  {
    name: 'Pacific/Wallis',
    offset: 'GMT+12:00',
  },
];

export const TIMEZONES = TIMEZONES_INTL.map((tz) => ({
  value: tz.name,
  label: `${tz.offset} - ${tz.name}`,
}));
